<template>
  <div>
    <!-- <div class="macdview" v-show="isactive">
      <macd-index></macd-index>
    </div>-->
    <ul class="tabeTagUl">
      <li
        v-for="(item,index) in tablename"
        :key="index"
        @click.stop="handleClick(item.key,index)"
        :class="{'nav_select_selected':item.class_true}"
      >{{item.value}}</li>
    </ul>
  </div>
</template>
<script>
export default {
    props:{
        footView:{
            type:Number,
            default:1
        },
        mainView:{
            type:Number,
            default:1
        }
    },
  data() {
    return {
      tablename: [
        { key: 2, value: "MACD", class_true: false },
        // { key: 16384, value: "量比", class_true: false },
        { key: 4096, value: "RSI", class_true: false },
        { key: 128, value: "DMA", class_true: false },
        { key: 256, value: "VR", class_true: false }
      ],
      isactive: false
    };
  },
  components: {},
  mounted() {

  },
  created() {
     this.tablename[0].class_true = true;
  },
  watch:{
      mainView:{
          handler(newValue,oldValue){
              const _this=this
              if(newValue!=10||this.footView==null){
                  return;
              }
              const arr=_this.tablename.filter(function (item) {
                  return item.key==_this.footView
              })
              if(arr.length==0){
                  this.tablename.map(function(val, index) {
                      index==0?(val.class_true = true):(val.class_true = false)
                  });
                  this.$emit("changeFootView", this.tablename[0].key);
              }else {
                  this.tablename.map(function(val, index) {
                      _this.footView === val.key ? (val.class_true = true) : (val.class_true = false);
                  });
                  this.$emit("changeFootView", this.footView);
              }
              // this.$refs.graph2.changeFootState(newValue);
          },
          deep:true
      },
      footView:{
          handler(newValue,oldValue){
              // this.$refs.graph2.changeFootState(newValue);
          },
          deep:true
      }
  },
  methods: {
    handleClick(key, i) {
      this.$emit("changeFootView", key);
      this.tablename.map(function(val, index) {
        i === index ? (val.class_true = true) : (val.class_true = false);
      });
    }
  }
};
</script>

<style scoped lang="scss">
  .tabeTagUl{
    display: flex;
    align-content: center;
    // padding-left: 16px;
    margin: 0;
  }
  .tabeTagUl>li{
    list-style: none;
    width: 67px;
    height: 22px;
    font-size: 12px;
    line-height: 22px;
    background: rgba(232, 241, 255, 1);
    text-align: center;
    margin: 0 1px;
    cursor: pointer;
    color:#333333;
    margin-top: 3px;
  }
  .tabeTagUl li:hover {
    color: #4eabf9;
  }
  .tabeTagUl li.nav_select_selected {
    background: #4eabf9;
    color: #fff;
  }
</style>
